import {Grid, Typography} from "@mui/material";
import {formatoFecha} from "../../Utilidades/formatoFecha";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";

export const Tarjeta_Descuento = ({item}) => {
    return (
        <Grid

            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, py: 1}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontSize: 12, fontWeight: 800}}>{formatoFecha(item.fecha)}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 9}}>
                <Typography sx={{fontWeight: 300}}>{item.descripcion}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 3}}>
                <Typography sx={{fontWeight: 800}}>{`-${formatoMoneda(item.valor)}`}</Typography>
            </Grid>


        </Grid>
    )
}